/* src/app/research/research.component.scss */
.research {
  background: white;
  color: black;
  height: 100%;
  padding: 150px 200px;
  font-family: "Campton-Light";
  text-align: left;
  font-size: 21px;
}
.research img {
  margin: 14px 0 50px;
}
.research ul {
  list-style-position: outside;
  margin-bottom: 1rem;
  margin: 0px;
  padding: 0px;
  margin-left: 1.25rem;
  margin-top: 1rem;
}
.research p {
  margin-bottom: 1rem;
  font-size: inherit;
  line-height: 1.6;
  text-rendering: optimizeLegibility;
}
.research h1 {
  font-size: 56px;
  line-height: 1.29;
  letter-spacing: 0.8px;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  font-weight: 700;
  font-family: "Campton-Bold";
}
.research a,
.research a:hover {
  color: #cca777;
  text-decoration: underline;
}
.research .dash {
  display: inline-block;
  width: 80px;
  height: 8px;
  padding: 0;
  margin: 0 0 24px;
  line-height: 8px;
}
.research .pressDash {
  background-color: #ff495c;
}
.research .newsDash {
  background-color: #d1a66f;
}
.research .buttons {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
/*# sourceMappingURL=research.component.css.map */
